
import './App.css';
import MarsMeteo from './Components/MarsMeteo/MarsMeteo';

function App() {
  return (
    <div className="App">
      <MarsMeteo/>
    </div>
  );
}

export default App;
